// Generate a random token
function generateToken(length = 32) {
    const array = new Uint8Array(length);
    crypto.getRandomValues(array);
    return Array.from(array, byte => byte.toString(16).padStart(2, '0')).join('');
  }
  
  // CSRF middleware
  export function setupCSRFProtection() {
    // Generate token on app initialization
    const csrfToken = generateToken();
    
    // Add meta tag with CSRF token if it doesn't exist
    if (!document.querySelector('meta[name="csrf-token"]')) {
      const meta = document.createElement('meta');
      meta.name = 'csrf-token';
      meta.content = csrfToken;
      document.head.appendChild(meta);
    }
    
    return {
      requestInterceptor: (config) => {
        if (!config.headers) {
          config.headers = {};
        }
        config.headers['X-CSRF-Token'] = csrfToken;
        return config;
      }
    };
  }
